import {Membership} from '../types';
import {UsersTeam} from './UserSessionContext.types';

export const mapMembershipToUsersTeam = (membership: Membership): UsersTeam => ({
  id: membership.team.id,
  name: membership.team.name,
  disabled: membership.team.disabled,
  role: membership.role,
});
